import { HostListener, Injectable, NgZone } from "@angular/core";
import { DwEventService, DwLoggingService, DwSecurityUserService } from "@devwareapps/devware-cap";
import { Observable } from "rxjs";
import { VideoRepositoryService } from "./video-repository.service";
import { DwPubSubService } from "../../z-devware/pubsub/dw-pub-sub-service";
import { DwPubSubEventTopics } from "../../z-devware/pubsub/models/dw-pub-sub-event-topics.model";
import { DwPubSubMessage } from "../../z-devware/pubsub/models/dw-pub-sub-message.model";
import { DwClientSessionUtilService } from "../../z-devware/pubsub/dw-client-session-util.service";

@Injectable({ providedIn: 'root' })
export class VideoMessagingService {
    private static videoBroadcastChannel: BroadcastChannel = null;

    constructor(private dwEventService: DwEventService, private dwPubSubService: DwPubSubService, private dwLoggingService: DwLoggingService, private dwSecurityUserService: DwSecurityUserService, private videoRepositoryService: VideoRepositoryService, private zone: NgZone) {
        this.setupBroadcastChannel();

        this.setupEvents();
    }

    setupEvents() {

        this.dwEventService.getEventData(DwPubSubEventTopics.messageReceived(VideoEvents.pauseVideo)).subscribe((message: DwPubSubMessage) => {
            this.dwPubSubService.emitDebug('Info', 'VMS - pause publish', message);
            //console.log('pause video message received via pubsub event', message);
            this.sendPauseVideoMessage({ reason: 'global-pause-video', event: message });
        });
    }

    private setupBroadcastChannel() {
        if (VideoMessagingService.videoBroadcastChannel) {
            return;
        }

        VideoMessagingService.videoBroadcastChannel = new BroadcastChannel('video-messaging-channel');

        VideoMessagingService.videoBroadcastChannel.onmessage = (event) => {

            this.sendPauseVideoMessage({ reason: 'video-started-in-another-tab', event: event.data });
        };


        document.onvisibilitychange = (event) => {
            this.onVisibilityChange(event);
        };

    }

    onVisibilityChange(event: Event): void {
        if (document.visibilityState === 'hidden') {
            this.sendPauseVideoMessage({ reason: 'tab-hidden' });
            // Perform actions when the tab is hidden (e.g., pause a video, stop polling)
        }
    }

    private sendPauseVideoMessage(message: any) {
        //console.log('pausing video', message);
        this.dwEventService.publishEvent(VideoEvents.pauseVideo, message, false);
    }

    publishVideoStartedMessage(videoId: number) {
        VideoMessagingService.videoBroadcastChannel.postMessage({ videoId });

        this.dwPubSubService.publishMessageToCurrentUser({
            Topic: VideoEvents.pauseVideo,
            Payload: `Video started in another tab: ${videoId}`,
            MessageId : DwClientSessionUtilService.generateUuid()
        });
    }

    getVideoPauseEvents(): Observable<any> {
        return this.dwEventService.getEvent(VideoEvents.pauseVideo);
    }
}

export enum VideoEvents {
    pauseVideo = 'pauseVideo',
}